import Text from '~/components/Text';
import type { PublicationFormQuestion } from '~/interfaces/form';
import { QuestionTypes } from '~/interfaces/form';

import DropdownInputs from './DropdownInputs';
import LongTextQuestion from './LongTextQuestion';
import MultipleChoiceInputs from './MultipleChoiceInputs';
import Question from './Question';

interface Props {
  questions: PublicationFormQuestion[];
}

const Questions = ({ questions }: Props) => {
  return (
    <div className="space-y-6">
      {questions.map((question: PublicationFormQuestion, index: number) => {
        const number = index + 1;
        const isFreeForm = question.question_type === QuestionTypes.FREE_FORM;
        const isMultipleChoice = question.question_type === QuestionTypes.MULTIPLE_CHOICE;
        const isLongText = question.question_type === QuestionTypes.LONG_TEXT;
        const isDropdown = question.question_type === QuestionTypes.DROPDOWN;

        return (
          <div key={question.id} className="space-y-1">
            <Text as="h6" size={'lg'} weight="semibold" theme="default" type="title">
              <span className="mr-2">{number}.</span>
              {question.prompt}
              {question.required && <span className="mr-2">&#42;</span>}
            </Text>
            <div>
              {isLongText && <LongTextQuestion question={question} />}
              {isFreeForm && (
                <Question name={question.id} required={question.required} type={question.custom_field.kind} />
              )}
              {isMultipleChoice && <MultipleChoiceInputs question={question} />}
              {isDropdown && <DropdownInputs question={question} />}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Questions;
